import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { SelectBox } from "devextreme-react/select-box";
import { TextBox } from "devextreme-react/text-box";
import { CheckBox } from "devextreme-react/check-box";
import { TextArea } from "devextreme-react/text-area";
import { FileUploader } from "devextreme-react/file-uploader";
import { Button } from "devextreme-react/button";

import { Toast } from "devextreme-react/toast";
import { useNavigate } from "react-router-dom";

import CCP_API from "api/ccpAPi";
import { useFetch, usePost, usePostFormData } from "@hooks/useCcpApi";
import { useFetch as useQCPFetch } from "@hooks/useQcpApi";
// import notify from "devextreme/ui/notify";
import "@common-components/cards/DarkCard.scss";
import { RadioGroup } from "devextreme-react";
import QCP_API from "api/qcpApi";

import notify from "devextreme/ui/notify";
import { showNotification } from "utils/helpers";

// Helper function for consistent notifications

// Usage examples:

export default function CCPForm() {
  const addCCP = usePost("add-ccp", CCP_API.CCP);
  const addCCPComments = usePost("add-ccp-comments", CCP_API.comments);

  const [selectedFiles, setSelectedFiles] = useState([]); // Store selected files
  const [uploadedFiles, setUploadedFiles] = useState([]); // Store uploaded file objects with statuses
  const [comments, setComments] = useState([]); // Store comments
  const [newComments, setNewComments] = useState([]); // Store comments
  const [newComment, setNewComment] = useState(""); // Track input
  const [loader, setLoader] = useState(false);

  //   const qcpMutation = usePost("addinspect", QCP_API.addQcpInspect);

  let userDetails = JSON.parse(localStorage.getItem("userDetails"));

  const [visible, setVisible] = useState(false); // Default visible
  const [toastMessage, setToastMessage] = useState(""); // Default message
  const [toastType, setToastType] = useState("error"); // Default error
  const [fileUploaderKey, setFileUploaderKey] = useState(0);
  const [attachmentUploaderKey, setAttachmentUploaderKey] = useState(0); // Key to force re-render
  const [selectedAttachments, setSelectedAttachments] = useState([]); // Store selected attachments
  const [uploadedAttachments, setUploadedAttachments] = useState([]); // Store uploaded attachment objects
  const currentDate = new Date().toISOString(); // Store ISO format for consistency
  const [count, setCount] = useState(0);
  const { data: approvedBY, loading: loadingApprove } = useQCPFetch(
    "approvedbyget",
    QCP_API.approvedBy
  );

  const { data: statuses } = useFetch("getStatus", CCP_API.getStatus);

  const validationSchema = Yup.object({
    type: Yup.string().oneOf(["1", "2"]).required("Test type is required"),

    batchNo: Yup.string().required("Batch number is required"),

    performedBy: Yup.string().required("Performed by is required"),
    approvedBy: Yup.string().required("Approved by is required"),

    noBrokenGlass: Yup.string().when("type", {
      is: "1",
      then: (schema) =>
        schema
          // .oneOf(["true", "false"], "Invalid value for noBrokenGlass")
          .required("Broken glass selection is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    noLooseMetalFragments: Yup.string().when("type", {
      is: "1",
      then: (schema) =>
        schema
          // .oneOf(["true", "false"], "Invalid value for noLooseMetalFragments")
          .required("Metal fragments selection is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    knivesAtProductionStartUp: Yup.number().when("type", {
      is: "2",
      then: (schema) =>
        schema
          .min(0, "Must be 0 or greater")
          .required("Knives startup count is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    knivesAtProductionEnd: Yup.number().when("type", {
      is: "2",
      then: (schema) =>
        schema
          .min(0, "Must be 0 or greater")
          .required("Knives end count is required"),
      // .test(
      //   "knives-count-match",
      //   "Knives end must be less than or equal to startup",
      //   function (value) {
      //     return value <= this.parent.knivesAtProductionStartUp;
      //   }
      // ),
      otherwise: (schema) => schema.notRequired(),
    }),

    scissorsAtProductionStartUp: Yup.number().when("type", {
      is: "2",
      then: (schema) =>
        schema
          .min(0, "Must be 0 or greater")
          .required("Scissors startup count is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    scissorsAtProductionEnd: Yup.number().when("type", {
      is: "2",
      then: (schema) =>
        schema
          .min(0, "Must be 0 or greater")
          .required("Scissors end count is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    knives: Yup.string().when("type", {
      is: "2",
      then: (schema) =>
        schema
          // .oneOf(["true", "false"], "Invalid value for knives")
          .required("Knives check is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    scissors: Yup.string().when("type", {
      is: "2",
      then: (schema) =>
        schema
          // .oneOf(["true", "false"], "Invalid value for scissors")
          .required("Scissors check is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    status: Yup.string().required("Batch number is required"),

    description: Yup.string()
      .min(1)
      .max(1000, "Maximum 1000 characters are allowed")
      .nullable()
      .required("Description is required"),
  });

  const showToast = (type, message) => {
    setToastType(type);
    setToastMessage(message);
    setVisible(true);
  };

  const handleAddComment = () => {
    if (newComment.trim() !== "") {
      const currentDate = new Date().toISOString(); // Store ISO format for consistency
      const updatedComments = [
        ...comments,
        { commentText: newComment, createdDateUTC: currentDate },
      ];

      setComments(updatedComments);

      let tempcom = newComments;
      tempcom.push({ commentText: newComment, createdDateUTC: currentDate });
      setNewComments(tempcom);
      setNewComment(""); // Clear input
    }
  };

  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      type: 1,
      batchNo: "",
      // licensePlate: "",
      // company: "",
      // driver: "",
      // truckTemp: "",
      // truckClean: false,
      performedBy: userDetails?.firstName + " " + userDetails?.lastName,
      approvedBy: "",
      noBrokenGlass: null,
      noLooseMetalFragments: null,
      knivesAtProductionStartUp: null,
      knivesAtProductionEnd: null,
      scissorsAtProductionStartUp: null,
      scissorsAtProductionEnd: null,
      description: null,
      knives: null,
      scissors: null,
      status: false,
      // comments: [],
      // files: [],
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        let formValues = values;
        console.log(values);

        setLoader(true);
        addCCP.mutate(values, {
          onSuccess: async (response) => {
            const ccp_id = response?.data; // Extract ccp_id from response
            if (!ccp_id) {
              showToast("error", "Failed to retrieve CCP ID");
              return;
            }

            const addCCPCommentsRequests = [];

            comments.map((comment) => {
              addCCPCommentsRequests.push({
                ccP_ID: ccp_id,
                commentText: comment.commentText,
              });
            });

            addCCPComments.mutate({ addCCPCommentsRequests });

            if (selectedFiles.length > 0) {
              for (const file of selectedFiles) {
                const formData = new FormData();
                formData.append("CCPId", ccp_id); // Attach qcp_id to each file
                formData.append("File", file); // Attach the file

                try {
                  await new Promise((resolve, reject) => {
                    imageUploadMutation.mutate(formData, {
                      onSuccess: () => {
                        console.log(`Image ${file.name} uploaded successfully`);
                        resolve();
                      },
                      onError: (error) => {
                        console.error(
                          `Error uploading image ${file.name}:`,
                          error
                        );
                        showToast(
                          "error",
                          `Failed to upload image ${file.name}`
                        );
                        reject(error);
                      },
                    });
                  });
                } catch (error) {
                  console.error(
                    "Stopping further uploads due to error:",
                    error
                  );
                  break; // Stop further uploads if an error occurs
                }
              }
            }
            if (selectedAttachments.length > 0) {
              console.log("selectedAttachments", selectedAttachments);
              for (const file of selectedAttachments) {
                const formData = new FormData();
                formData.append("CCPId", ccp_id); // Attach qcp_id to each file
                formData.append("File", file); // Attach the file

                try {
                  await new Promise((resolve, reject) => {
                    documentUploadMutation.mutate(formData, {
                      onSuccess: () => {
                        resolve();
                      },
                      onError: (error) => {
                        console.error(
                          `Error uploading image ${file.name}:`,
                          error
                        );
                        showToast(
                          "error",
                          `Failed to upload image ${file.name}`
                        );
                        reject(error);
                      },
                    });
                  });
                } catch (error) {
                  console.error(
                    "Stopping further uploads due to error:",
                    error
                  );
                  break; // Stop further uploads if an error occurs
                }
              }
            }
            showNotification("CCP Data Saved Successfully", "success");
            // showNotification("Save successful!", "success");
            // formik.resetForm()

            if (formik.values.type === 1) {
              // formik.values.noBrokenGlass = null;
              // formik.values.noLooseMetalFragments = null;
              // formik.values.type = 2;
              formik.setValues({
                batchNo: formValues.batchNo,

                noBrokenGlass: null,
                noLooseMetalFragments: null,
                type: 2,
                performedBy:
                  userDetails?.firstName + " " + userDetails?.lastName,
              });
              setComments([]);
              setSelectedFiles([]);
              setUploadedFiles([]);
              setSelectedAttachments([]);
              setAttachmentUploaderKey(0);
              setNewComments([]);
            }

            if (formik.values.type === 2) {
              // formik.values.knivesAtProductionStartUp = null;
              // formik.values.knivesAtProductionEnd = null;
              // formik.values.scissorsAtProductionStartUp = null;
              // formik.values.scissorsAtProductionEnd = null;
              // formik.values.knives = null;
              // formik.values.scissors = null;
              // formik.values.type = 1;
              formik.setValues({
                batchNo: formValues.batchNo,

                knivesAtProductionStartUp: null,
                knivesAtProductionEnd: null,
                scissorsAtProductionStartUp: null,
                scissorsAtProductionEnd: null,
                knives: null,
                scissors: null,
                type: 2,
                performedBy:
                  userDetails?.firstName + " " + userDetails?.lastName,
              });
              setComments([]);
              setSelectedFiles([]);
              setUploadedFiles([]);
              setSelectedAttachments([]);
              setAttachmentUploaderKey(0);
              setNewComments([]);
            }

            if (count + 1 === 2) {
              navigate("/quality/fillet/ccp");
            } else {
              setCount(count + 1);
            }

            setLoader(false);
          },
          onError: (error) => {
            setLoader(false);
            if (
              error.response.data.errors[0].errorMessageEn ===
              "BoxShortNO already exist"
            ) {
              showNotification("Batch already exist", "error");
            }
            if (
              error.response.data.errors[0].errorMessageEn ===
              "BatchNo doesn't exist"
            ) {
              showNotification("Batch does not exist", "error");
            }
          },
        });
      } catch (error) {
        console.error("Error saving CCP:", error);
        setLoader(false);
        showNotification("Failed to save CCP data", "error", 3000);
      }
    },
  });

  console.log(formik.errors);

  const imageUploadMutation = usePostFormData("uploadImages", CCP_API.images);
  const documentUploadMutation = usePostFormData(
    "uploadDocument",
    CCP_API.document
  );

  const handleFileChange = (e) => {
    const files = e.value;
    const filePreviews = files.map((file) => ({
      name: file.name,
      size: file.size, // Include file size
      url: URL.createObjectURL(file), // Generate a preview URL for the file
      status: "pending", // Initial status
    }));

    setSelectedFiles(files); // Store selected files for upload
    setUploadedFiles(filePreviews); // Update preview list
  };

  const handleAttachmentsChange = (e) => {
    const files = e.value;
    const attachmentDetails = files.map((file) => ({
      name: file.name,
      size: file.size, // Include file size
      status: "pending", // Initial status
    }));

    setSelectedAttachments(files); // Store selected files for upload
    setUploadedAttachments(attachmentDetails); // Update preview list
  };

  React.useEffect(() => {
    if (statuses?.data?.length > 0) {
      formik.setFieldValue("status", statuses.data[0].orderStatusId); // Set default to the first item's ID
    }
  }, [statuses]);

  const handleDeleteImage = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
    setSelectedFiles((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      setFileUploaderKey((k) => k + 1); // force FileUploader to re-render
      return updated;
    });
  };

  const handleDeleteAttachment = (index) => {
    setUploadedAttachments((prev) => prev.filter((_, i) => i !== index));
    setSelectedAttachments((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      setAttachmentUploaderKey((k) => k + 1); // Force FileUploader to re-render
      return updated;
    });
  };

  const handleDeleteComment = (index) => {
    let tempComments = comments;
    tempComments.splice(index, 1);
    setComments((prev) => [...tempComments]);
  };

   useEffect(() => {
      let bNum = localStorage.getItem("batchNum");
      if (bNum && bNum !== "undefined") {
        formik.setFieldValue("batchNo", bNum);
     
      } else {
        formik.setFieldValue("batchNo", "");
    
      }
    }, []);

  return (
    <>
      <Toast
        visible={visible}
        message={toastMessage}
        type={toastType}
        displayTime={2000}
        onHiding={() => setVisible(false)}
        position={{ my: "top right", at: "top right", offset: "10 10" }}
      />

      <form onSubmit={formik.handleSubmit}>
        <p className="font-medium text-xl">Truck Inspection</p>
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-x-5 lg:space-y-0 space-y-3">
          <div className="border rounded border-gray-50 dark-bg p-4">
            <div className="w-full flex items-center mb-2">
              <p className="whitespace-nowrap text-xl font-medium">Add Info:</p>
              <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
            </div>
            <div className="flex lg:flex-row flex-col lg:items-center items-start space-y-2 space-x-0 lg:space-x-12 lg:space-y-0 mb-4">
              <label className="text-sm relative font-bold ">
                <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                  *
                </span>
                Test Type
              </label>
              <RadioGroup
                items={[
                  { id: 1, text: "Production Startup" },
                  { id: 2, text: "End Production" },
                ]}
                valueExpr="id"
                displayExpr="text"
                layout="horizontal"
                value={formik.values.type}
                onValueChanged={(e) => formik.setFieldValue("type", e.value)}
                isValid={!formik.errors.type || !formik.touched.type}
                validationError={
                  formik.errors.type ? { message: formik.errors.type } : null
                }
              />
            </div>
            <div className="block lg:grid lg:grid-cols-2 space-y-4 lg:space-y-0 gap-4">
              <div>
                <label className="text-sm mb-1 relative">
                  <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                    *
                  </span>
                  Batch No.
                </label>
                <TextBox
                  placeholder="Enter Batch No..."
                  value={formik.values.batchNo}
                  onValueChange={(value) =>
                    formik.setFieldValue("batchNo", value.trim())
                  }
                  onBlur={formik.handleBlur}
                />
                {formik.touched.batchNo && formik.errors.batchNo && (
                  <div
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {formik.errors.batchNo}
                  </div>
                )}
              </div>
              <div>
                <label className="text-sm mb-1 relative">
                  <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                    *
                  </span>
                  Description
                </label>
                <TextBox
                  placeholder="Enter Description"
                  value={formik.values.description}
                  onValueChange={(value) =>
                    formik.setFieldValue("description", value.trim())
                  }
                  onBlur={formik.handleBlur}
                />
                {formik.touched.description && formik.errors.description && (
                  <div
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {formik.errors.description}
                  </div>
                )}
              </div>
              <div>
                <label className="text-sm mb-1 relative">
                  <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                    *
                  </span>
                  Performed by
                </label>
                <TextBox
                  placeholder="Enter Name"
                  disabled={true}
                  value={userDetails?.firstName + " " + userDetails?.lastName}
                  defaultValue={
                    userDetails?.firstName + " " + userDetails?.lastName
                  }
                />
                {formik.touched.performedBy && formik.errors.performedBy && (
                  <div
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {formik.errors.performedBy}
                  </div>
                )}
              </div>
              <div>
                <label className="text-sm mb-1 relative">
                  <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                    *
                  </span>
                  Approved by
                </label>
                <SelectBox
                  dataSource={approvedBY?.data || []}
                  displayExpr={(item) =>
                    item
                      ? item.firstName
                          .toLowerCase()
                          .split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join(" ")
                      : ""
                  } // Capitalize the first letter of each word
                  valueExpr="firstName"
                  value={formik.values.approvedBy}
                  onValueChanged={(e) =>
                    formik.setFieldValue("approvedBy", e.value)
                  }
                  // isValid={
                  //   !(formik.errors.approvedBy && formik.touched.approvedBy)
                  // }
                  // validationError={
                  //   formik.errors.approvedBy
                  //     ? { message: formik.errors.approvedBy }
                  //     : null
                  // }
                  placeholder="Select an option"
                />
                {formik.touched.approvedBy && formik.errors.approvedBy && (
                  <div
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {formik.errors.approvedBy}
                  </div>
                )}
              </div>
              {formik.values.type === 2 && (
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                      *
                    </span>
                    Knives at Production Startup
                  </label>
                  <TextBox
                    placeholder=""
                    value={formik.values.knivesAtProductionStartUp}
                    onValueChange={(value) =>
                      formik.setFieldValue(
                        "knivesAtProductionStartUp",
                        value.trim()
                      )
                    }
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.knivesAtProductionStartUp &&
                    formik.errors.knivesAtProductionStartUp && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {formik.errors.knivesAtProductionStartUp}
                      </div>
                    )}
                </div>
              )}
              {formik.values.type === 2 && (
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                      *
                    </span>
                    Knives at Production End
                  </label>
                  <TextBox
                    placeholder=""
                    value={formik.values.knivesAtProductionEnd}
                    onValueChange={(value) =>
                      formik.setFieldValue(
                        "knivesAtProductionEnd",
                        value.trim()
                      )
                    }
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.knivesAtProductionEnd &&
                    formik.errors.knivesAtProductionEnd && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {formik.errors.knivesAtProductionEnd}
                      </div>
                    )}
                </div>
              )}
              {formik.values.type === 2 && (
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                      *
                    </span>
                    Scissors at Production Startup
                  </label>
                  <TextBox
                    placeholder=""
                    value={formik.values.scissorsAtProductionStartUp}
                    onValueChange={(value) =>
                      formik.setFieldValue(
                        "scissorsAtProductionStartUp",
                        value.trim()
                      )
                    }
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.scissorsAtProductionStartUp &&
                    formik.errors.scissorsAtProductionStartUp && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {formik.errors.scissorsAtProductionStartUp}
                      </div>
                    )}
                </div>
              )}
              {formik.values.type === 2 && (
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                      *
                    </span>
                    Scissors at Production End
                  </label>
                  <TextBox
                    placeholder=""
                    value={formik.values.scissorsAtProductionEnd}
                    onValueChange={(value) =>
                      formik.setFieldValue(
                        "scissorsAtProductionEnd",
                        value.trim()
                      )
                    }
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.scissorsAtProductionEnd &&
                    formik.errors.scissorsAtProductionEnd && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {formik.errors.scissorsAtProductionEnd}
                      </div>
                    )}
                </div>
              )}
              {formik.values.type === 2 && (
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                      *
                    </span>
                    Knives
                  </label>
                  <RadioGroup
                    items={[
                      { id: true, text: "Ok" },
                      { id: false, text: "Not Ok" },
                    ]}
                    valueExpr="id"
                    displayExpr="text"
                    layout="horizontal"
                    value={formik.values.knives}
                    onValueChanged={(e) =>
                      formik.setFieldValue("knives", e.value)
                    }
                    isValid={!(formik.errors.knives && formik.touched.knives)}
                    validationError={
                      formik.errors.knives
                        ? { message: formik.errors.knives }
                        : null
                    }
                  />
                </div>
              )}
              {formik.values.type === 2 && (
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                      *
                    </span>
                    Scissors
                  </label>
                  <RadioGroup
                    items={[
                      { id: true, text: "Ok" },
                      { id: false, text: "Not Ok" },
                    ]}
                    valueExpr="id"
                    displayExpr="text"
                    layout="horizontal"
                    value={formik.values.scissors}
                    onValueChanged={(e) =>
                      formik.setFieldValue("scissors", e.value)
                    }
                    isValid={
                      !(formik.errors.scissors && formik.touched.scissors)
                    }
                    validationError={
                      formik.errors.scissors
                        ? { message: formik.errors.scissors }
                        : null
                    }
                  />
                </div>
              )}
              {formik.values.type === 1 && (
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                      *
                    </span>
                    No broken glass / other fragments before startup:
                  </label>
                  <RadioGroup
                    items={[
                      { id: true, text: "Ok" },
                      { id: false, text: "Not Ok" },
                    ]}
                    valueExpr="id"
                    displayExpr="text"
                    layout="horizontal"
                    value={formik.values.noBrokenGlass}
                    onValueChanged={(e) =>
                      formik.setFieldValue("noBrokenGlass", e.value)
                    }
                    // isValid={
                    //   !(
                    //     formik.errors.noBrokenGlass &&
                    //     formik.touched.noBrokenGlass
                    //   )
                    // }
                    // validationError={
                    //   formik.errors.noBrokenGlass
                    //     ? { message: formik.errors.noBrokenGlass }
                    //     : null
                    // }
                  />
                  {formik.touched.noBrokenGlass &&
                    formik.errors.noBrokenGlass && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "0px",
                        }}
                      >
                        {formik.errors.noBrokenGlass}
                      </div>
                    )}
                </div>
              )}

              {formik.values.type === 1 && (
                <div>
                  <label className="text-sm mb-1 relative">
                    <span className="text-red-500 text-lg absolute top-[-4px] right-[-12px]">
                      *
                    </span>
                    No loose metal fragments / parts before startup:
                  </label>
                  <RadioGroup
                    items={[
                      { id: true, text: "Ok" },
                      { id: false, text: "Not Ok" },
                    ]}
                    valueExpr="id"
                    displayExpr="text"
                    layout="horizontal"
                    value={formik.values.noLooseMetalFragments}
                    onValueChanged={(e) =>
                      formik.setFieldValue("noLooseMetalFragments", e.value)
                    }
                    // isValid={
                    //   !(
                    //     formik.errors.noLooseMetalFragments &&
                    //     formik.touched.noLooseMetalFragments
                    //   )
                    // }
                    // validationError={
                    //   formik.errors.noLooseMetalFragments
                    //     ? { message: formik.errors.noLooseMetalFragments }
                    //     : null
                    // }
                  />
                  {formik.touched.noLooseMetalFragments &&
                    formik.errors.noLooseMetalFragments && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "0px",
                        }}
                      >
                        {formik.errors.noLooseMetalFragments}
                      </div>
                    )}
                </div>
              )}
              {/* <div>
                <label className="text-sm mb-1 relative">
                  <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                    *
                  </span>
                  License Plate
                </label>
                <TextBox
                  placeholder="Enter License Plate..."
                  value={formik.values.licensePlate}
                  onValueChange={(value) =>
                    formik.setFieldValue("licensePlate", value.trim())
                  }
                  onBlur={formik.handleBlur}
                />
                {formik.touched.licensePlate && formik.errors.licensePlate && (
                  <div
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {formik.errors.licensePlate}
                  </div>
                )}
              </div>
              <div>
                <label className="text-sm mb-1 relative">
                  <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                    *
                  </span>
                  Company
                </label>
                <TextBox
                  placeholder="Enter Company Name..."
                  value={formik.values.company}
                  onValueChange={(value) =>
                    formik.setFieldValue("company", value.trim())
                  }
                  onBlur={formik.handleBlur}
                />
                {formik.touched.company && formik.errors.company && (
                  <div
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {formik.errors.company}
                  </div>
                )}
              </div>
              <div>
                <label className="text-sm mb-1 relative">
                  <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                    *
                  </span>
                  Driver
                </label>
                <TextBox
                  placeholder="Enter Driver Name..."
                  value={formik.values.driver}
                  onValueChange={(value) =>
                    formik.setFieldValue("driver", value.trim())
                  }
                  onBlur={formik.handleBlur}
                />
                {formik.touched.driver && formik.errors.driver && (
                  <div
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {formik.errors.driver}
                  </div>
                )}
              </div>
              <div>
                <label className="text-sm mb-1 relative">
                  <span className="text-red-500 text-lg absolute top-[-4px] right-[-10px]">
                    *
                  </span>
                  Truck Temp °C
                </label>
                <TextBox
                  value={formik.values.truckTemp}
                  onValueChanged={(e) =>
                    formik.setFieldValue("truckTemp", e.value.trim())
                  }
                  placeholder="Enter Temp..."
                  // width="100%"
                  onBlur={formik.handleBlur}
                />
                {formik.touched.truckTemp && formik.errors.truckTemp && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}
                  >
                    {formik.errors.truckTemp}
                  </div>
                )}
              </div> */}
              <div>
                <label className="text-sm mb-1 relative">Status</label>
                {statuses && statuses?.data && (
                  <SelectBox
                    dataSource={statuses?.data || []}
                    displayExpr="description"
                    valueExpr="orderStatusId"
                    value={formik.values.status} // Bind to formik's status field
                    // value={values.statusID}
                    onValueChanged={(e) => {
                      formik.setFieldValue("status", e.value);
                    }}
                  />
                )}
              </div>
            </div>
            <div className="w-full flex items-center mt-4 mb-2">
              <p className="whitespace-nowrap text-xl font-medium">
                Add Picture(s):
              </p>
              <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
            </div>
            <div className="border-2 border-dashed hover:bg-gray-50 dark-bg rounded px-4 py-4 text-center">
              <FileUploader
                key={fileUploaderKey}
                multiple
                accept=".png, .jpg, .jpeg, jpg, .gif, .webp, .svg"
                onValueChanged={handleFileChange}
                value={selectedFiles}
                showFileList={false}
              />
              {uploadedFiles.length > 0 && (
                <ul className="grid grid-cols-3 gap-4">
                  {uploadedFiles.map((file, index) => (
                    <li key={index} className="text-sm relative">
                      <img
                        src={file.url}
                        alt={file.name}
                        className="w-full h-24 object-cover rounded border"
                      />
                      <p className="text-xs text-center mt-1 break-words mb-0">
                        {file.name}
                      </p>
                      <button
                        type="button"
                        className="absolute top-1 right-1 bg-red-600 text-white ml-10 text-xs rounded-full px-[7px] py-1"
                        onClick={() => handleDeleteImage(index)}
                      >
                        ✕
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className="w-full flex items-center mt-4 mb-2">
              <p className="whitespace-nowrap text-xl font-medium">
                Add Attachment(s):
              </p>
              <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
            </div>
            <div className="border-2 border-dashed hover:bg-gray-50 dark-bg rounded px-4 py-4 text-center">
              <FileUploader
                multiple
                accept=".pdf, .docx, .xlsx .doc, .pptx, .txt, .ppt, .xls, .csv, .zip, .rar"
                key={attachmentUploaderKey}
                value={selectedAttachments}
                showFileList={false}
                onValueChanged={handleAttachmentsChange} // Triggered when files are selected
              />
              {uploadedAttachments.length > 0 && (
                <ul className="space-y-2">
                  {uploadedAttachments.map((file, index) => (
                    <li
                      key={index}
                      className="text-sm text-gray-700 flex justify-between items-center"
                    >
                      <span>{file.name}</span>
                      <button
                        type="button"
                        className="text-red-700 text-xs rounded-full p-1"
                        onClick={() => handleDeleteAttachment(index)}
                      >
                        ✕
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          <div className="border rounded border-gray-50 dark-bg p-4 flex flex-col">
            <div className="w-full flex items-center mb-2">
              <p className="whitespace-nowrap text-xl font-medium">
                Add Comments:
              </p>
              <div className="flex-grow h-px bg-gray-300 light-bg ml-2"></div>
            </div>
            <div className="max-h-full overflow-y-auto lg:pr-2 pr-0 custom-scrollbar space-y-2 mb-4">
              {comments?.map((comment, index) => (
                <div
                  key={index}
                  className="bg-gray-100 hover:bg-gray-200 dark-bg hover:cursor-pointer rounded px-3 py-2 border"
                >
                  <div className="flex items-center justify-end space-x-5">
                    <p className="text-xs mb-0 whitespace-nowrap">
                      {new Date(
                        comment.createdDateUTC || currentDate
                      ).toLocaleDateString("en-US")}
                    </p>
                    <button
                      type="button"
                      className="text-red-700 text-xs"
                      onClick={() => handleDeleteComment(index)}
                    >
                      ✕
                    </button>
                  </div>
                  <p className="break-words mt-2">{comment.commentText}</p>
                </div>
              ))}
            </div>
            <div className="mt-auto">
              <TextArea
                placeholder="Add comment..."
                height={100}
                maxLength={123}
                stylingMode="outlined"
                mode="multiline"
                value={newComment} // Controlled input
                onValueChanged={(e) => setNewComment(e.value)} // Only update newComment
              />
              <Button
                className="mt-2"
                icon="plus"
                text="Add more comment"
                stylingMode="text"
                onClick={handleAddComment} // Call function on click
              />
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end mt-6">
          <Button
            className="me-3"
            width={100}
            text="Cancel"
            type="normal"
            stylingMode="outlined"
            onClick={() => {
              navigate("/quality/fillet/ccp");
            }}
          />
          <Button
            width={100}
            text={loader ? "Saving" : "Save"}
            stylingMode="contained"
            type="default"
            disabled={loader}
            useSubmitBehavior
          />
        </div>
      </form>
    </>
  );
}
